module.exports = __webpack_public_path__ + "img/rsxs.2cdd1def.png";